module.exports = __webpack_public_path__ + "img/kkb_arena18.ed6c5647.jpg";